import { render, staticRenderFns } from "./OwnersDriversTable.vue?vue&type=template&id=29fd4a4e&"
import script from "./OwnersDriversTable.vue?vue&type=script&lang=js&"
export * from "./OwnersDriversTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports